<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <help :text="$t('help.promo_create')" :title="$t('help.promo_create_title')"/>
    <div class="white-container">
      <promo-view @save="savePromo"/>
    </div>
  </div>
</template>

<script>
  import PromoView from "./PromoView.vue";

  export default {
    components: {
      PromoView
    },
    middleware: 'auth',
    name: 'PromoCreation',
    props: {
      caption: {
        type: String,
      },
    },
    methods: {
      savePromo(params) {
        this.postData('promos', params, '/promos');
      }
    }
  }
</script>